import type { ApiClient, IApiJsonRequest } from '../../ApiClient';
import type { IApiAppPlatform } from '../Apps';
import type {
  IApiBuildsResponseBody,
  IApiRunBuildsRequestBody,
} from './BuildsApi.types';

export class BuildsApi {
  public constructor(private client: ApiClient) {}

  public async getAll(
    appId: string,
    platform?: IApiAppPlatform,
    withHistory?: boolean,
  ): Promise<IApiBuildsResponseBody> {
    const request: IApiJsonRequest = {
      method: 'get',
      path: platform
        ? `/apps/${appId}/builds/v2/${platform}`
        : `/apps/${appId}/builds/v2`,
      params: withHistory ? { all: 'true' } : undefined,
    };

    const data =
      await this.client.fetchJsonStandardized<IApiBuildsResponseBody>(request, {
        appId,
      });

    return data;
  }

  public async run(
    appId: string,
    body?: IApiRunBuildsRequestBody,
  ): Promise<IApiBuildsResponseBody> {
    const request: IApiJsonRequest = {
      method: 'put',
      path: `/apps/${appId}/builds/v2`,
      body: body,
    };

    const data =
      await this.client.fetchJsonStandardized<IApiBuildsResponseBody>(request, {
        appId,
      });

    return data;
  }
}
